module.exports = __webpack_public_path__ + "static/media/logo secondary.a401a572.svg";